import React from 'react'
import { Facebook, Github, Twitter, YouTube ,LinkedIn } from "../components/AllSvgs"
import styled from 'styled-components'
import { DarkTheme } from '../components/Themes'
import { lightTheme } from '../components/Themes'
import { motion } from 'framer-motion';

const Icons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 2rem;
  z-index: 10; /* Increased z-index to be above DarkDiv */
  
  gap: 0; /* Remove gap to prevent spacing issues */

  & > *:not(:last-child) {
    margin-bottom: 0.8rem; /* Reduced margin between icons */
  }

  @media (max-width: 768px) {
    left: 1rem;
    
    & > *:not(:last-child) {
      margin-bottom: 0.6rem;
    }
  }

  @media (max-width: 480px) {
    left: 0.5rem;
    bottom: 0rem;
    
    & > *:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  @media (max-width: 320px) {
    transform: scale(0.9);
    bottom: 0.5rem;
    left: 0.3rem;
    
    & > *:not(:last-child) {
      margin-bottom: 0.4rem;
    }
  }
`;

const Line = styled(motion.span)`
  width: 2px;
  height: 8rem;
  background-color: ${props => props.color === 'dark' ? DarkTheme.text : DarkTheme.body};
  margin-top: 0.5rem; /* Add margin to connect with last icon */
  
  @media (max-width: 768px) {
    height: 6rem;
    margin-top: 0.4rem;
  }
  
  @media (max-width: 480px) {
    height: 4rem;
    margin-top: 0.3rem;
  }
  
  @media (max-width: 320px) {
    height: 3rem;
    margin-top: 0.2rem;
  }
`

const SocialIcons = (props) => {
  // Calculate responsive icon size
  const getIconSize = () => {
    if (window.innerWidth <= 320) return 18;
    if (window.innerWidth <= 480) return 20;
    if (window.innerWidth <= 768) return 22;
    return 25;
  };
  
  const [iconSize, setIconSize] = React.useState(getIconSize());
  
  React.useEffect(() => {
    const handleResize = () => {
      setIconSize(getIconSize());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get the appropriate line height based on screen size
  const getLineHeight = () => {
    if (window.innerWidth <= 320) return '3rem';
    if (window.innerWidth <= 480) return '4rem';
    if (window.innerWidth <= 768) return '6rem';
    return '8rem';
  };

  return (
    <Icons>
      <motion.div
      initial={{scale:0 }}
      animate={{ scale: [0, 1, 1.5, 1] }}
      transition={{ type: "spring", duration: 1, delay: 1 }}
      >
      <a style={{ color: 'inherit' }} href="https://linkedin.com/in/pratikk-dev/" target="_blank" rel="noopener noreferrer">
      <LinkedIn width={iconSize} height={iconSize} fill={props.theme === "dark" ? DarkTheme.text  : DarkTheme.body} />
      </a>
      </motion.div>
      <motion.div
      initial={{scale:0 }}
      animate={{ scale: [0, 1, 1.5, 1] }}
      transition={{ type: "spring", duration: 1, delay: 1.2 }}
      >
        <a style={{ color: 'inherit' }} href="https://github.com/pratikk5" target="_blank" rel="noopener noreferrer">
          <Github width={iconSize} height={iconSize} fill={props.theme === "dark" ? DarkTheme.text : DarkTheme.body} />
        </a>
      </motion.div>
      <motion.div
      initial={{scale:0 }}
      animate={{ scale: [0, 1, 1.5, 1] }}
      transition={{ type: "spring", duration: 1, delay: 1.3 }}
      >
        <a style={{ color: 'inherit' }} href="https://x.com/pratikpatildev" target="_blank" rel="noopener noreferrer">
          <Twitter width={iconSize} height={iconSize} fill={props.theme === "dark" ? DarkTheme.text : DarkTheme.body} theme={props.theme} />
        </a>
      </motion.div>
      <motion.div
      initial={{scale:0 }}
      animate={{ scale: [0, 1, 1.5, 1] }}
      transition={{ type: "spring", duration: 1, delay: 1.4 }}
      >
        <a style={{ color: 'inherit' }} href="https://www.facebook.com/pratikpatildev/" target="_blank" rel="noopener noreferrer">
          <Facebook width={iconSize} height={iconSize} fill={props.theme === "dark" ? DarkTheme.text : DarkTheme.body} />
        </a>
      </motion.div>
      <motion.div
      initial={{scale:0 }}
      animate={{ scale: [0, 1, 1.5, 1] }}
      transition={{ type: "spring", duration: 1, delay: 1.6 }}
      >
        <a style={{ color: 'inherit' }} href="https://www.youtube.com/@techinyourpocket5" target="_blank" rel="noopener noreferrer">
          <YouTube width={iconSize} height={iconSize} fill={props.theme === "dark" ? DarkTheme.text : DarkTheme.body} />
        </a>
      </motion.div>
      <Line color={props.theme}
        initial={{ height: 0 }}
        animate={{ height: getLineHeight() }}
        transition={{ type: 'spring', duration: 1, delay: 0.8 }}
      />
    </Icons>
  )
}
export default SocialIcons